import { Injectable, Type } from "@angular/core";
import { Routes } from "@angular/router";
import { DynamicRoute, IDynamicRoutesProvider } from "core";
import { CUSTOMERS_DESCRIBE } from "../constants";
import { Customers } from "../customers/customers"
import { CustomersList } from "../customers-list/customers-list"
import { CustomersDetail } from "../customers-detail/customers-detail";

@Injectable({ providedIn: 'root' })
export class CustomersRoutesProvider extends IDynamicRoutesProvider {

    override componentMap: Record<string, Type<any>> = {
        'customers': Customers,
        'customers-list': CustomersList,
        'customer-detail': CustomersDetail,
    };

    // deve corrispondere all'id nel json della chiamate delle rotte
    override describe(): String {
        return 'customers';
    }

    override evaluate(dynamicRoute: DynamicRoute[]): Routes {
        return this.buildRoutes(dynamicRoute, CUSTOMERS_DESCRIBE);
    }
}
